export type InviteCodeUiStatus =
  | "active"
  | "used"
  | "expired"
  | "deactivated";

export type InviteCodeEligibilityUi = "ALL" | "NEW_USERS" | "EXISTING_USERS";

export type InviteCodeStatusFilter =
  | "all"
  | "active"
  | "used"
  | "expired"
  | "deactivated";

/** Form state for Create Invite Code (maps to CreateInviteCodeBody). */
export type CreateInviteCodeInput = {
  code: string;
  ownerEmail: string;
  depositReward: number | "";
  minDepositUSD: number | "";
  tradeReward: number | "";
  minTradeUSD: number | "";
  /** Selected asset symbols, e.g. ["BTC","USDT"]. */
  requiredPairs: string[];
  eligibility: InviteCodeEligibilityUi;
  expiryDate: string;
  maxMembers: number | "";
};

/** Maps UI status filter pills → API `status` query (empty = all). */
export function statusFilterToApi(
  filter: InviteCodeStatusFilter
): "" | "ACTIVE" | "USED" | "EXPIRED" | "DEACTIVATED" {
  if (filter === "all") return "";
  return filter.toUpperCase() as
    | "ACTIVE"
    | "USED"
    | "EXPIRED"
    | "DEACTIVATED";
}
